/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const AccountInfoRowStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 32px;
`;

export const AccountInfoRowTitleStyled = styled.div`
    width: 387px;
    margin-right: 20px;
`;

export const AccountInfoRowHintStyled = styled.div`
    margin-top: 4px;
    color: ${colors.textColorOpacity};
`;

export const AccountInfoButtonHolderStyled = styled.div`
    margin-top: 24px;
    margin-bottom: 24px;
`;

export const AccountInfoRowBodyStyled = styled.div`
    .account-financial-info__cashback-link {
        margin-left: 8px;
    }
`;

export const AccountInfoRowOnTimeStyled = styled.div`
    margin-top: 4px;
    color: ${colors.textColorOpacity};
`;
